import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormText, FormGroup, Label } from "reactstrap";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0) ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() : '';
  });
}

const AddNewContributorsModal = props => {
  const token = getCookie().token;
  const { modal, toggleModal, setNewContributor, subUserId, subUserEndpoint, parentUserOnly } = props;
  const [error, setError] = React.useState(false);
  const [errorDupl, setErrorDupl] = React.useState(false);
  const [validationErr, setValidationErr] = useState(false);

  const { t } = useTranslation();

  return (
    <Modal isOpen={modal} centered={true}>
      <ModalHeader>{t("tracks.contributorsRow.form.modal.header")}</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            name: '',
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().required(t("tracks.contributorsRow.form.modal.body.message.nameRequired")).test('is-uppercase', t("tracks.contributorsRow.form.modal.body.message.nameMustNotBeInUppercase"), value => value !== value.toUpperCase())
          })}
          onSubmit={({ name }, { setStatus, setSubmitting }) => {
            setStatus();
            const reg = new RegExp(/^([A-Z][a-zA-ZáéíóúÁÉÍÓÚñÑ’'-]{1,25})(\s([A-Z][a-zA-ZáéíóúÁÉÍÓÚñÑ’'-]{1,25})){1,6}$/);

            if (reg.test(name) === false ){
              setValidationErr(true);
              return;
            } else {
              setValidationErr(false);
            }

            let nameTitleCase = toTitleCase(name);

            const options = {
              'method': "GET",
              mode: 'cors',
              headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": X_API_KEY,
                'Content-Type': 'application/json'
              }
            }

            const contributorObj = {
              name: nameTitleCase,
              ...(subUserId && { sub_user_id: subUserId || null})
            };

            axios.get(`${API_URL}contributors/${subUserEndpoint}?search=${nameTitleCase}${parentUserOnly}`, options).then(res => {
              if (res.status === 200){

                const list = res.data.results.length > 0 ? res.data.results : [];

                const getOne = list.filter(i => i.name === nameTitleCase);

                if (getOne.length > 0) {
                  setErrorDupl(true)
                } else {
                  axios
                  .post(
                    `${API_URL}contributors/`,
                    contributorObj,
                    options
                  )
                  .then(res => {
                    if (res.status === 201) {
                      const contributors = res.data;
                      contributors && setNewContributor();
                      contributors && toggleModal(false);
                    }
                  })
                  .catch(err => {
                    setError(true);
                    
                  });
                }
              }
            }).catch(err => {
              setError(true);
            });

          }}
          render={({ errors, status, touched, isSubmitting, setFieldValue }) => (
            <Form className="mt-3" id="loginform">
              <FormGroup>
                <Label>{t("tracks.contributorsRow.form.modal.body.label.name")}</Label>
                <Field name="name" type="text" className={'form-control' + (errors.name && touched.name ? ' is-invalid' : '')} onChange={(e) => setFieldValue('name', e.target.value.replace(/[&\/\\#,+()$~^%.'":*?<>{}]/g,''))} />
                <ErrorMessage name="name" component="div" className="invalid-feedback" />
                {validationErr && <div className="invalid-feedback" style={{display: 'block'}}>{t("tracks.contributorsRow.form.modal.body.message.insertRealName")}</div>}
                <FormText color="muted" style={{padding: '5px 0'}}>
                  {t("tracks.contributorsRow.form.modal.body.help_text.name")}
                </FormText>
              </FormGroup>
              {
                errorDupl && <p style={{    fontSize: "12px",color: "red",margin: "4px 0 4px 0"}}>{t("tracks.contributorsRow.form.modal.body.message.errorContributorAlreadyExists")}</p>
              }
              <ModalFooter>
                <Button color="success" type="submit">{t("tracks.contributorsRow.form.modal.button.createNew")}</Button>{' '}
                <Button color="secondary" onClick={() => toggleModal(false)}>{t("tracks.contributorsRow.form.modal.button.cancel")}</Button>
              </ModalFooter>
            </Form>
          )}
        />

      </ModalBody>

    </Modal>
  );
};

export default AddNewContributorsModal;
